import type { Batch, BatchItem } from '@rpldy/uploady'
import { FILE_STATES } from '@rpldy/uploady'
import { useEffect, useRef } from 'react'

import { useListenersContext } from '../UploadManage.context'

export const useUploadBatchError = (id: string, func: (data: BatchItem[]) => void) => {
    const { batchListener } = useListenersContext()

    const callback = (data: BatchItem[]) => {
        func(data)
        const batchItemIds = data.reduce<string[]>((prev, cur) => {
            if (cur.state === FILE_STATES.ERROR) {
                prev.push(cur.id)
            }
            return prev
        }, [])
        batchListener.removeUploadingBatchItem(id, batchItemIds)
    }

    const latestFunc = useRef<(data: BatchItem[]) => void>(callback)
    latestFunc.current = callback

    useEffect(() => {
        batchListener.add(latestFunc.current, id, FILE_STATES.ERROR)

        // return () => {
        //     batchListener.remove(id)
        // }
    }, [id, batchListener])
}
